// extracted by mini-css-extract-plugin
export default {"cls1":"qRpE9F04VChlQTAAGFkZ","cls2":"vRuCIUPukscALsuTGtnz qRpE9F04VChlQTAAGFkZ","isPhone":"HYX9Np2BeGctYHGRwsa2"};